import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  NavMenuItem as NavItem,
  Tooltip,
} from '@alefeducation/ui-elements-library-core';
import withActiveMenuItem from './HOCs/withActiveMenuItem';

interface NavMenuItemProps {
  children: string;
  to: string;
  icon?: React.ReactElement;
  isCollapsed?: boolean;
  'data-testid'?: string;

  onClick?(): void;
}

const NavMenuItemWrapper: React.FC<NavMenuItemProps> = ({
  children,
  to,
  icon,
  isCollapsed = false,
  ...rest
}: NavMenuItemProps) => {
  const history = useHistory();
  const onClick = () => history.push(to);

  if (isCollapsed) {
    return (
      <Tooltip
        id={`nav-tooltip-${rest['data-testid'] ?? to}`}
        content={children}
        position="right"
      >
        <NavItem onClick={onClick} icon={icon} aria-label={children} {...rest}>
          {null}
        </NavItem>
      </Tooltip>
    );
  }

  return (
    <NavItem onClick={onClick} icon={icon} {...rest}>
      {children}
    </NavItem>
  );
};

const NavMenuItem = withActiveMenuItem(NavMenuItemWrapper);
export default NavMenuItem;
